import { Box, TextField, Typography } from '@mui/material'
import React from 'react'
import { InputLabelStyled } from './PresentingComplaintSection'
import { riskRatingOpt } from './formOptions'
import RadioButtonController from '../../../../components/RadioButtonController/RadioButtonController'
import { CustomInputLable, InputContainer, ParentContainerSection } from '../DiabeticForm'
import InputController from '../../../../components/InputController/InputController'

const SummaryDiabetic = (props) => {
    const {control, errors, getValues} = props
  return (
    <>
       <ParentContainerSection  heading="Section H - Summary Risk Rating for Diabetic Retionopathy">
               
       <Box sx={{ display: "flex", gap: "0.5rem", mb: "1rem"}}>
               <InputLabelStyled required >Risk Rating</InputLabelStyled>
                  <RadioButtonController
                                    name="risk_rating"
                                    control={control}
                                    errors={errors}
                                    options={riskRatingOpt}
                                    isRow={false}
                                    isDisabled={true}
                            />
            </Box>
    
            <InputContainer sx={{"& > label:first-of-type": { width: "13.5% !important"}}}>

<CustomInputLable>Comments</CustomInputLable>
<InputController
  name="diabetic_comments"
  control={control}
  errors={errors}
  comment
  fullWidth
  size="small"
  isDisabled
/>
</InputContainer>

            {/* <Box sx={{ display: "flex", gap: "1rem", alignItems: "center", }}>
                    <InputLabelStyled>Comments</InputLabelStyled>
                        <TextField
                            id="diabetic_comments"
                            label="Comments"
                            multiline
                            disabled
                            rows={4}
                            defaultValue={getValues("diabetic_comments")}
                            sx={{flexBasis: "792px",  "& .MuiInputBase-input.Mui-disabled": {
            WebkitTextFillColor: (theme)=>theme.palette.black.main,
        },
        "& .MuiInputLabel-root.Mui-disabled":{
          color:(theme)=>theme.palette.black.main
        }}}
                            inputProps={{
                                style:{
                                    width: "100%"
                                }
                            }}
                        /> */}
                {/* </Box> */}

        </ParentContainerSection>
    </>
  )
}

export default SummaryDiabetic